import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logo from "../../assets/logo.png";
import googleIcon from "../../assets/googleIcon.svg";
import Spinner from "../../shared/Spinner/Spinner";
import FieldError from "../../shared/FieldError/FieldError";

import styles from "./Login.module.scss";

const Login = () => {
  const token = localStorage.getItem("authToken");
  const navigate = useNavigate();

  // if token exists, then redirect to home
  // useEffect(() => {
  //   if (token) {
  //     navigate("/");
  //   }
  // }, [token]);

  // submit loading
  const [loading, setLoading] = useState(false);

  // input states
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // errors
  const [emailError, setEmailError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setEmailError("Email is required!");
    }
    if (!password) {
      setPasswordError("Password is required!");
    }

    if (email && password) {
      setLoading(true);
      const payload = {
        email,
        password,
      };

      const response = await login(payload);
      setLoading(false);
      if (response.status === 200) {
        toast.success("User Logged Successfully");

        navigate("/");
      } else {
        toast.error(response.data.message);
      }
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}></div>

      <div className={styles.rightContainer}>
        <img src={logo} alt="logo" className={styles.logo} />
        <form 
        // onSubmit={handleSubmit}
        >
          <p>Welcome back</p>
          <h3>Login to your account</h3>

          <div className={styles.field}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="johnsnow@gmail.com"
              value={email}
              autoComplete="on"
              onChange={(e) => setEmail(e.target.value)}
            />
            {/* {emailError && <FieldError message={emailError} />} */}
          </div>
          <div className={styles.field}>
            <label>Password</label>
            <input
              type="password"
              name="password"
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              value={password}
              autoComplete="off"
              onChange={(e) => setPassword(e.target.value)}
            />
            {/* {passwordError && <FieldError message={passwordError} />} */}
          </div>
          <small onClick={() => navigate("/auth/forgot")}>
            Forgot password?
          </small>

          <div className={styles.btnContainer}>
            <button type="submit">{loading ? <Spinner /> : "Login now"}</button>
            <button>
              <img src={googleIcon} alt="google" />
              Or sign-in with google
            </button>
          </div>
        </form>
        <p className={styles.noAccount}>
          Dont have an account?{" "}
          <span onClick={() => navigate("/auth/register")}>
            Join free today
          </span>
        </p>
      </div>
    </div>
  );
};

export default Login;
